import { combineReducers } from '@reduxjs/toolkit';
import testCasesReducer from './testCases/testCasesSlice'
import authReducer, {setLogout} from './auth/authSlice'
import projectReducer from './projects/ProjectSlice';
import navigationReducer from './navigation/navigationSlice'; 
import columnVisibilityReducer from './filter/columnVisibilitySlice';
import testRunReducer from './testRun/testRunSlice';
import columnForTestrunCaseReducer from './filter/columnVisibilitySliceforTestrunCases';
import snackbarReducer from './snakbar/snackbarSlice';
import attachmentReducer from './attachment/attachmentsSlice';
import llmModelReducer from './llmModels/llmModelSlice';
import roleStepperReducer from './roleStepper/roleStepperSlice';
import testRunDetailsSlice from './testDetials/index.js';
import userPreferenceReducer from './userPreference/userPreferenceSlice';
import commonReducer from './commonslice';
import replayReducer from './replayslice';
import queryReducer from './query/querySlice';
import automationStudioReducer from './automationStudio/automationStudioSlice';
import automationStudioNewReducer from './automationStudioNew/automationStudioNewSlice';

const appReducer = combineReducers({
    testCases: testCasesReducer,
    auth: authReducer,
    projects : projectReducer,
    navigation: navigationReducer, 
    columnVisibility: columnVisibilityReducer,
    testrun: testRunReducer,
    columnVisibilityForTestrunCases: columnForTestrunCaseReducer,
    snackbar: snackbarReducer,
    attachments: attachmentReducer,
    llmModels: llmModelReducer,
    roleStepper: roleStepperReducer,
    testrundetails: testRunDetailsSlice,
    userPreference: userPreferenceReducer,
    common: commonReducer,
    replay: replayReducer,
    query: queryReducer,
    automationStudio: automationStudioReducer,
    automationStudioNew: automationStudioNewReducer,
});

const rootReducer = (state, action) => {
    if (action.type === setLogout.type) {
      // Reset all state when logout is dispatched
      state = undefined;
    }
    return appReducer(state, action);
  };

export default rootReducer;